module.exports = __webpack_public_path__ + "static/img/logo_white.d0a4a01c.png";